import { 
  collection,
  addDoc,
  doc,
  getDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  serverTimestamp,
  arrayUnion,
  arrayRemove
} from 'firebase/firestore';
import { db } from '../firebase';

// ==================== KOLEKSİYONLAR ====================
const customersCollection = collection(db, 'Customers');
const ordersCollection = collection(db, 'Orders');

// ==================== YARDIMCI FONKSİYONLAR ====================

const convertTimestamp = (timestamp) => {
  if (!timestamp) return null;
  if (timestamp instanceof Date) return timestamp;
  if (timestamp.toDate && typeof timestamp.toDate === 'function') {
    return timestamp.toDate();
  }
  if (typeof timestamp === 'string') return new Date(timestamp);
  if (timestamp.seconds) return new Date(timestamp.seconds * 1000);
  return null;
};

// ==================== MÜŞTERİ YÖNETİMİ ====================

/**
 * Tüm müşterileri getir (Geliştirilmiş - Sipariş bilgileriyle)
 */
export const getAllCustomers = async () => {
  try {
    const querySnapshot = await getDocs(customersCollection);
    
    const customers = [];
    querySnapshot.forEach((document) => {
      const data = document.data();
      customers.push({
        id: document.id,
        ...data,
        createdAt: convertTimestamp(data.createdAt),
        updatedAt: convertTimestamp(data.updatedAt),
        lastOrderDate: convertTimestamp(data.lastOrderDate)
      });
    });
    
    console.log(`✅ Toplam ${customers.length} müşteri yüklendi`);
    
    return { success: true, customers };
  } catch (error) {
    console.error('❌ Müşteriler getirilirken hata:', error);
    return { success: false, error: error.message, customers: [] };
  }
};

/**
 * Müşteri detayını getir
 */
export const getCustomerById = async (customerId) => {
  try {
    const customerRef = doc(db, 'Customers', customerId);
    const snapshot = await getDoc(customerRef);
    
    if (!snapshot.exists()) {
      return { success: false, error: 'Müşteri bulunamadı' };
    }
    
    const data = snapshot.data();
    return { 
      success: true, 
      customer: { 
        id: snapshot.id,
        ...data,
        createdAt: convertTimestamp(data.createdAt),
        updatedAt: convertTimestamp(data.updatedAt),
        lastOrderDate: convertTimestamp(data.lastOrderDate)
      } 
    };
  } catch (error) {
    console.error('getCustomerById error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * 🔥 YENİ: Manuel müşteri oluştur (Admin tarafından)
 */
export const createCustomer = async (customerData) => {
  try {
    // Email kontrolü
    const emailQuery = query(customersCollection, where('email', '==', customerData.email));
    const emailSnapshot = await getDocs(emailQuery);
    
    if (!emailSnapshot.empty) {
      return { success: false, error: 'Bu email ile kayıtlı müşteri zaten var' };
    }
    
    const newCustomer = {
      name: customerData.name,
      email: customerData.email,
      phone: customerData.phone || null,
      address: customerData.address || null,
      city: customerData.city || null,
      district: customerData.district || null,
      zipCode: customerData.zipCode || null,
      status: 'active',
      totalOrders: 0,
      totalSpent: 0,
      lastOrderDate: null,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      notes: customerData.notes || '',
      tags: customerData.tags || []
    };
    
    const docRef = await addDoc(customersCollection, newCustomer);
    
    console.log('✅ Müşteri manuel oluşturuldu:', docRef.id);
    
    return { 
      success: true, 
      customerId: docRef.id,
      message: 'Müşteri başarıyla oluşturuldu'
    };
  } catch (error) {
    console.error('❌ Müşteri oluşturma hatası:', error);
    return { success: false, error: error.message };
  }
};

/**
 * 🔥 YENİ: Müşteri bilgilerini güncelle
 */
export const updateCustomer = async (customerId, updateData) => {
  try {
    const customerRef = doc(db, 'Customers', customerId);
    
    const updates = {
      ...updateData,
      updatedAt: serverTimestamp()
    };
    
    // Hassas alanları kaldır
    delete updates.id;
    delete updates.createdAt;
    delete updates.totalOrders;
    delete updates.totalSpent;
    delete updates.lastOrderDate;
    
    await updateDoc(customerRef, updates);
    
    console.log('✅ Müşteri güncellendi:', customerId);
    
    return { 
      success: true, 
      message: 'Müşteri bilgileri güncellendi'
    };
  } catch (error) {
    console.error('❌ Müşteri güncelleme hatası:', error);
    return { success: false, error: error.message };
  }
};

/**
 * 🔥 YENİ: Müşteri sil (Soft delete)
 */
export const deleteCustomer = async (customerId) => {
  try {
    const customerRef = doc(db, 'Customers', customerId);
    
    // Önce siparişleri kontrol et
    const ordersQuery = query(
      ordersCollection,
      where('customerId', '==', customerId)
    );
    const ordersSnapshot = await getDocs(ordersQuery);
    
    if (!ordersSnapshot.empty) {
      // Siparişi olan müşteri - Soft delete
      await updateDoc(customerRef, {
        status: 'inactive',
        deletedAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      });
      
      console.log('✅ Müşteri pasif edildi (siparişleri var):', customerId);
      
      return { 
        success: true, 
        message: 'Müşteri pasif edildi'
      };
    } else {
      // Siparişi olmayan müşteri - Tam silme
      await deleteDoc(customerRef);
      
      console.log('✅ Müşteri tamamen silindi:', customerId);
      
      return { 
        success: true, 
        message: 'Müşteri tamamen silindi'
      };
    }
  } catch (error) {
    console.error('❌ Müşteri silme hatası:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Müşteri notlarını güncelle
 */
export const updateCustomerNotes = async (customerId, notes) => {
  try {
    const customerRef = doc(db, 'Customers', customerId);
    
    await updateDoc(customerRef, {
      notes: notes,
      updatedAt: serverTimestamp()
    });
    
    return { success: true, message: 'Notlar kaydedildi' };
  } catch (error) {
    console.error('Müşteri notları güncellenemedi:', error);
    return { success: false, error: error.message };
  }
};

/**
 * 🔥 YENİ: Müşteri etiketlerini güncelle
 */
export const updateCustomerTags = async (customerId, tags) => {
  try {
    const customerRef = doc(db, 'Customers', customerId);
    
    await updateDoc(customerRef, {
      tags: tags,
      updatedAt: serverTimestamp()
    });
    
    return { success: true, message: 'Etiketler güncellendi' };
  } catch (error) {
    console.error('❌ Etiket güncelleme hatası:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Müşterinin siparişlerini getir
 */
export const getCustomerOrders = async (customerId) => {
  try {
    const q = query(
      ordersCollection, 
      where('customerId', '==', customerId),
      orderBy('createdAt', 'desc')
    );
    
    const snapshot = await getDocs(q);
    const orders = snapshot.docs.map(doc => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        createdAt: convertTimestamp(data.createdAt),
        updatedAt: convertTimestamp(data.updatedAt)
      };
    });
    
    console.log(`✅ Müşteri ${customerId} için ${orders.length} sipariş bulundu`);
    
    return { success: true, orders };
  } catch (error) {
    console.error('Müşteri siparişleri alınamadı:', error);
    return { success: false, error: error.message, orders: [] };
  }
};

/**
 * 🔥 YENİ: Email ile müşteri ara
 */
export const getCustomerByEmail = async (email) => {
  try {
    const q = query(customersCollection, where('email', '==', email));
    const snapshot = await getDocs(q);
    
    if (snapshot.empty) {
      return { success: false, error: 'Müşteri bulunamadı' };
    }
    
    const data = snapshot.docs[0].data();
    return { 
      success: true, 
      customer: {
        id: snapshot.docs[0].id,
        ...data,
        createdAt: convertTimestamp(data.createdAt),
        lastOrderDate: convertTimestamp(data.lastOrderDate)
      }
    };
  } catch (error) {
    console.error('Email ile müşteri arama hatası:', error);
    return { success: false, error: error.message };
  }
};

/**
 * 🔥 YENİ: VIP müşterileri getir
 */
export const getVIPCustomers = async () => {
  try {
    const q = query(
      customersCollection,
      where('totalOrders', '>=', 10),
      orderBy('totalOrders', 'desc')
    );
    
    const snapshot = await getDocs(q);
    const customers = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      createdAt: convertTimestamp(doc.data().createdAt),
      lastOrderDate: convertTimestamp(doc.data().lastOrderDate)
    }));
    
    return { success: true, customers };
  } catch (error) {
    console.error('VIP müşteriler alınamadı:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Kullanıcı adreslerini getir
 */
export const getUserAddresses = async (userId) => {
  try {
    const userRef = doc(db, 'Users', userId);
    const userDoc = await getDoc(userRef);
    
    if (userDoc.exists()) {
      const addresses = userDoc.data().addresses || [];
      return { success: true, addresses };
    }
    return { success: false, error: 'Kullanıcı bulunamadı' };
  } catch (error) {
    console.error('Adresler alınırken hata:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Adres ekle
 */
export const addAddress = async (userId, addressData) => {
  try {
    const userRef = doc(db, 'Users', userId);
    
    const newAddress = {
      id: Date.now().toString(),
      ...addressData,
      createdAt: new Date().toISOString()
    };

    await updateDoc(userRef, {
      addresses: arrayUnion(newAddress),
      updatedAt: serverTimestamp()
    });

    return { success: true, address: newAddress };
  } catch (error) {
    console.error('Adres eklenirken hata:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Adres sil
 */
export const deleteAddress = async (userId, addressId) => {
  try {
    const userRef = doc(db, 'Users', userId);
    const userDoc = await getDoc(userRef);
    
    if (!userDoc.exists()) {
      return { success: false, error: 'Kullanıcı bulunamadı' };
    }

    const addresses = userDoc.data().addresses || [];
    const addressToRemove = addresses.find(addr => addr.id === addressId);
    
    if (addressToRemove) {
      await updateDoc(userRef, {
        addresses: arrayRemove(addressToRemove),
        updatedAt: serverTimestamp()
      });
    }

    return { success: true };
  } catch (error) {
    console.error('Adres silinirken hata:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Kart ekle
 */
export const addCard = async (userId, cardData) => {
  try {
    const userRef = doc(db, 'Users', userId);
    
    const lastFour = cardData.cardNumber.replace(/\s/g, '').slice(-4);
    
    const newCard = {
      id: Date.now().toString(),
      cardName: cardData.cardName,
      lastFour: lastFour,
      expiryMonth: cardData.expiryMonth,
      expiryYear: cardData.expiryYear,
      createdAt: new Date().toISOString()
    };

    await updateDoc(userRef, {
      savedCards: arrayUnion(newCard),
      updatedAt: serverTimestamp()
    });

    return { success: true, card: newCard };
  } catch (error) {
    console.error('Kart eklenirken hata:', error);
    return { success: false, error: error.message };
  }
};

export default {
  getAllCustomers,
  getCustomerById,
  createCustomer,
  updateCustomer,
  deleteCustomer,
  updateCustomerNotes,
  updateCustomerTags,
  getCustomerOrders,
  getCustomerByEmail,
  getVIPCustomers,
  getUserAddresses,
  addAddress,
  deleteAddress,
  addCard
};